module.exports = __webpack_public_path__ + "static/media/dispatch_systemmoduleC-icon4.228d00eb.png";